// extracted by mini-css-extract-plugin
module.exports = {"infrastructure-rows":"a10a3f92e9--infrastructure-rows--qcVlZ","non-clickable-heading-wrapper":"a10a3f92e9--non-clickable-heading-wrapper--lXIlw"};